import { Component, HostListener, inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog'
import { MatButton } from '@angular/material/button'
import { TranslateModule } from '@ngx-translate/core'

@Component({
  selector: 'app-remove-item-with-children-confirm-dialog',
  standalone: true,
  imports: [MatDialogClose, MatButton, TranslateModule, MatDialogActions, MatDialogContent, MatDialogTitle],
  templateUrl: './remove-item-with-children-confirm-dialog.component.html',
  styleUrl: './remove-item-with-children-confirm-dialog.component.scss',
})
export class RemoveItemWithChildrenConfirmDialogComponent {
  dialog = inject(MatDialogRef<RemoveItemWithChildrenConfirmDialogComponent>)

  @HostListener('document:keydown', ['$event'])
  triggerKeys(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      this.closeDialog(false)
    }
    if (event.key === 'Enter') {
      this.closeDialog(true)
    }
  }

  closeDialog(afterCloseStatus: boolean): void {
    this.dialog.close(afterCloseStatus)
  }
}
